import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

function AddWishListItemForm({ wishListId, onAddItem, onClose }) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAddItem({ name, description, link, imageUrl });
    onClose();
  };

  return createPortal(
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-dark-surface rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200 transition-colors">
        <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center bg-gray-50 dark:bg-gray-800 transition-colors">
          <h3 className="text-lg font-bold text-gray-800 dark:text-white">{t('addNewItem')}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label htmlFor="name" className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-1">
              {t('name')} <span className="text-red-500">*</span>
            </label>
            <input 
              type="text" 
              id="name" 
              value={name} 
              onChange={(e) => setName(e.target.value)} 
              className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white" 
              required 
              placeholder={t('enterItemName', 'Введіть назву')}
            />
          </div>
          
          <div>
            <label htmlFor="description" className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-1">
              {t('description')}
            </label>
            <textarea 
              id="description" 
              value={description} 
              onChange={(e) => setDescription(e.target.value)} 
              className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all resize-none dark:text-white"
              rows="3"
              placeholder={t('enterDescription', 'Введіть опис')}
            ></textarea>
          </div>
          
          <div>
            <label htmlFor="link" className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-1">
              {t('link')} <span className="text-red-500">*</span>
            </label>
            <input 
              type="url" 
              id="link" 
              value={link} 
              onChange={(e) => setLink(e.target.value)} 
              className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white" 
              required 
              placeholder="https://example.com"
            />
          </div>
          
          <div>
            <label htmlFor="imageUrl" className="block text-sm font-bold text-gray-700 dark:text-gray-300 mb-1">
              {t('imageUrl')}
            </label>
            <input 
              type="url" 
              id="imageUrl" 
              value={imageUrl} 
              onChange={(e) => setImageUrl(e.target.value)} 
              className="w-full p-3 bg-gray-50 dark:bg-gray-800 border-none rounded-xl focus:ring-2 focus:ring-primary-100 outline-none transition-all dark:text-white" 
              placeholder="https://example.com/image.jpg"
            />
          </div>
          
          <div className="flex gap-3 pt-2">
            <button 
              type="button" 
              onClick={onClose} 
              className="flex-1 py-3 rounded-xl font-bold text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              {t('cancel')}
            </button>
            <button 
              type="submit" 
              className="flex-1 btn-primary py-3 rounded-xl font-bold flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faPlus} />
              {t('add')}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}

export default AddWishListItemForm;
